import React from 'react';
import parse from 'html-react-parser';

/**
 * BannerSectionStyle6 — Used by Departments page (inline card-style banner with image)
 */
export default function BannerSectionStyle6({ imgUrl, title, subTitle }) {
  return (
    <div className="max-w-[1200px] mx-auto px-6 md:px-16">
      <div className="relative bg-cream-dark rounded-md overflow-hidden flex flex-col md:flex-row items-center gap-0 shadow-sm border border-[rgba(139,26,26,0.08)]">
        {/* Image column */}
        {imgUrl && (
          <div className="hidden md:flex items-end justify-center bg-cream w-full md:w-2/5 min-h-[280px] p-8">
            <img src={imgUrl} alt="Banner" className="max-h-[260px] w-auto object-contain" />
          </div>
        )}

        {/* Text column */}
        <div className="flex flex-col justify-center p-10 md:p-14 flex-1">
          <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
            <span className="w-[24px] h-px bg-gold block" />
            Noohra Services
          </div>
          <h2 className="font-serif text-3xl md:text-4xl font-light leading-[1.2] text-charcoal mb-4">
            {parse(title || '')}
          </h2>
          {subTitle && (
            <p className="text-base leading-[1.75] text-mid font-light m-0">
              {parse(subTitle)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
